import { render, staticRenderFns } from "./Mt5Details.vue?vue&type=template&id=a4dce11c"
import script from "./Mt5Details.vue?vue&type=script&lang=js"
export * from "./Mt5Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports